import React from 'react';

import { cn } from '@lyearn/style';
import { Box } from '@lyearn/ui';

import { ModalProps } from '../../types';
import DialogFooter from './DialogFooter';
import DialogHeader from './DialogHeader';

const Dialog: React.FC<ModalProps> = (props) => {
  const { action, onClose, header, children, showCloseBtn = true, className } = props;

  return (
    <Box className="z-40 flex flex-1 flex-col overflow-auto">
      {header ? <DialogHeader header={header} /> : null}
      {children ? <Box className={cn('overflow-y-auto', className)}>{children}</Box> : null}
      {action ? (
        <DialogFooter action={action} showCloseBtn={showCloseBtn} onClose={onClose} />
      ) : null}
    </Box>
  );
};

export default Dialog;
